import './css/ChankangItemPackageDetail.css'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Image, Button, Table, Row, Col } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'
import { formItemLayout } from '../../js/globalParam'
import { Base64 } from 'js-base64'

const { Column } = Table

export default function MealDetail() {

  const [mealData, setMealData] = useState<any>()
  const [tableData, setTableData] = useState<any[]>([])
  const [flagList, setFlagList] = useState<any[]>([])

  let { id }: { id: string | undefined } = useParams()

  // 初始化数据
  useEffect(() => {
    baseAxiosNoInfo.get('/chankang_center/item_package/detail', { params: { item_id: id } }).then((res: any) => {
      if (res) {
        setMealData(res)
        setTableData(res.item_attribute_base)
        setFlagList(res.item_flag.split(','))
      }
    })
  }, [])

  return <div className="common-level2-edit">
    {/* 产康中心 -> 产康项目管理 -> 产康套餐列表 -> 套餐详情 */}
    <h2>套餐详情</h2>

    <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
      <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
    </div>

    <div className="common-main">
      <Form {...formItemLayout} >
        <Form.Item label="套餐名称">
          {mealData?.item_name}
        </Form.Item>

        <Form.Item label="套餐标签">
          {flagList.map((el: any) => (
            <span style={{ display: 'inline-block', textAlign: 'center' }}>{el.split('&&&')[0]}；</span>
          ))}
        </Form.Item>

        <Form.Item label="套餐图片">
          {mealData?.file_url_list.map((item: any, index: any) => (<Image height={100} width={100} key={index} src={item} />))}
        </Form.Item>

        <Form.Item label="参考价格">
          {mealData?.suggest_price}
        </Form.Item>

        <Form.Item label="服务详情">
          <div dangerouslySetInnerHTML={{ __html: mealData?.item_intro_detail ? Base64.fromBase64(mealData?.item_intro_detail) : '' }}></div>
        </Form.Item>

        <Form.Item label="温馨提示">
          <div dangerouslySetInnerHTML={{ __html: mealData?.attention ? Base64.fromBase64(mealData?.attention) : '' }}></div>
        </Form.Item>

        <Form.Item label="基本项目"  >
          <Table dataSource={tableData} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="item_id">
            <Column title="项目名称" dataIndex="item_name" key="item_name" />
            <Column title="标准次数" dataIndex="standard_times" key="standard_times" />
          </Table>
        </Form.Item>
      </Form>
    </div>
  </div>
}